module.exports = __webpack_public_path__ + "img/H2F5_new.4c35733d.jpg";